let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5sYR0")).then(() => parcelRequire('dENL7'));